module.exports = __webpack_public_path__ + "static/media/search.c4bef903.svg";